'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _subjects = require('../actions/subjects');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchSubjects),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchSubject),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(editSubject),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(createSubject),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(deleteSubject),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchSubjectsRequest),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(fetchSubjectRequest),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(editSubjectRequest),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(createSubjectRequest),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(deleteSubjectRequest);

function fetchSubjects(_ref) {
    var filter = _ref.filter;
    var disciplineId, response;
    return regeneratorRuntime.wrap(function fetchSubjects$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    disciplineId = filter.disciplineId;
                    _context.next = 4;
                    return (0, _effects.call)(_api.request, 'get', '/subjects?disciplines=' + disciplineId);

                case 4:
                    response = _context.sent;
                    _context.next = 7;
                    return (0, _effects.put)(_subjects.actionCreators.fetchSubjectsSucceeded(response.data, filter));

                case 7:
                    _context.next = 13;
                    break;

                case 9:
                    _context.prev = 9;
                    _context.t0 = _context['catch'](0);
                    _context.next = 13;
                    return (0, _effects.put)(_subjects.actionCreators.fetchSubjectsFailed('Ocorreu um erro na busca de assuntos'));

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 9]]);
}

function fetchSubject(_ref2) {
    var subjectId = _ref2.subjectId;
    var response;
    return regeneratorRuntime.wrap(function fetchSubject$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/subjects/' + subjectId);

                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)(_subjects.actionCreators.fetchSubjectSucceeded(response.data));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)(_subjects.actionCreators.fetchSubjectFailed());

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 8]]);
}

function editSubject(_ref3) {
    var subjectId = _ref3.subjectId,
        changes = _ref3.changes,
        redirect = _ref3.redirect;
    return regeneratorRuntime.wrap(function editSubject$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/subjects/' + subjectId, changes);

                case 3:
                    _context3.next = 5;
                    return (0, _effects.put)(_subjects.actionCreators.editSubjectSucceeded());

                case 5:
                    if (!redirect) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 8;
                    return (0, _effects.call)(redirect);

                case 8:
                    _context3.next = 14;
                    break;

                case 10:
                    _context3.prev = 10;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 14;
                    return (0, _effects.put)(_subjects.actionCreators.editSubjectFailed());

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 10]]);
}

function createSubject(_ref4) {
    var subject = _ref4.subject,
        redirect = _ref4.redirect;
    return regeneratorRuntime.wrap(function createSubject$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/subjects/', subject);

                case 3:
                    _context4.next = 5;
                    return (0, _effects.put)(_subjects.actionCreators.createSubjectSucceeded());

                case 5:
                    if (!redirect) {
                        _context4.next = 8;
                        break;
                    }

                    _context4.next = 8;
                    return (0, _effects.call)(redirect);

                case 8:
                    _context4.next = 14;
                    break;

                case 10:
                    _context4.prev = 10;
                    _context4.t0 = _context4['catch'](0);
                    _context4.next = 14;
                    return (0, _effects.put)(_subjects.actionCreators.createSubjectFailed());

                case 14:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[0, 10]]);
}

function deleteSubject(_ref5) {
    var subjectId = _ref5.subjectId,
        filter = _ref5.filter;
    var response;
    return regeneratorRuntime.wrap(function deleteSubject$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.prev = 0;
                    _context5.next = 3;
                    return (0, _effects.call)(_api.request, 'DELETE', '/subjects/' + subjectId);

                case 3:
                    response = _context5.sent;

                    if (!response.data.success) {
                        _context5.next = 11;
                        break;
                    }

                    _context5.next = 7;
                    return (0, _effects.put)(_subjects.actionCreators.deleteSubjectSucceeded());

                case 7:
                    _context5.next = 9;
                    return (0, _effects.put)(_subjects.actionCreators.fetchSubjectsRequest(filter));

                case 9:
                    _context5.next = 13;
                    break;

                case 11:
                    _context5.next = 13;
                    return (0, _effects.put)(_subjects.actionCreators.deleteSubjectFailed());

                case 13:
                    _context5.next = 19;
                    break;

                case 15:
                    _context5.prev = 15;
                    _context5.t0 = _context5['catch'](0);
                    _context5.next = 19;
                    return (0, _effects.put)(_subjects.actionCreators.deleteSubjectFailed(_context5.t0));

                case 19:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this, [[0, 15]]);
}

function fetchSubjectsRequest() {
    return regeneratorRuntime.wrap(function fetchSubjectsRequest$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_subjects.actionTypes.FETCH_SUBJECTS_REQUEST, fetchSubjects);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function fetchSubjectRequest() {
    return regeneratorRuntime.wrap(function fetchSubjectRequest$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(_subjects.actionTypes.FETCH_SUBJECT_REQUEST, fetchSubject);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function editSubjectRequest() {
    return regeneratorRuntime.wrap(function editSubjectRequest$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(_subjects.actionTypes.EDIT_SUBJECT_REQUEST, editSubject);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

function createSubjectRequest() {
    return regeneratorRuntime.wrap(function createSubjectRequest$(_context9) {
        while (1) {
            switch (_context9.prev = _context9.next) {
                case 0:
                    _context9.next = 2;
                    return (0, _effects.takeLatest)(_subjects.actionTypes.CREATE_SUBJECT_REQUEST, createSubject);

                case 2:
                case 'end':
                    return _context9.stop();
            }
        }
    }, _marked9, this);
}

function deleteSubjectRequest() {
    return regeneratorRuntime.wrap(function deleteSubjectRequest$(_context10) {
        while (1) {
            switch (_context10.prev = _context10.next) {
                case 0:
                    _context10.next = 2;
                    return (0, _effects.takeLatest)(_subjects.actionTypes.DELETE_SUBJECT_REQUEST, deleteSubject);

                case 2:
                case 'end':
                    return _context10.stop();
            }
        }
    }, _marked10, this);
}

exports.default = [createSubjectRequest, deleteSubjectRequest, fetchSubjectsRequest, fetchSubjectRequest, editSubjectRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/subjects.js
// module id = 2235
// module chunks = 0